<div
    class="container-fluid well"
    data-test-automation="tenure-interests">
    <h5>{{title}}</h5>
    @if (hasFormerTenureInterests()) {
        <div class="row">
            <div class="col-xs-12">
                <table class="table table-hover table-striped">
                    @if (showHeader()) {
                        <thead>
                            <tr class="default">
                                <td nowrap>{{interestsUiConfig.broughtForwardNotificationsTableSubjectColumnLabel}}</td>
                                <td nowrap>{{interestsUiConfig.broughtForwardNotificationsTableParentTenureColumnLabel}}</td>
                                <td nowrap>{{interestsUiConfig.broughtForwardNotificationsTableEndorsementColumnLabel}}</td>
                                <td nowrap>{{interestsUiConfig.broughtForwardNotificationsTableOriginColumnLabel}}</td>
                                <td nowrap>{{interestsUiConfig.broughtForwardNotificationsTableActionColumnLabel}}</td>
                                @if (interestsUiConfig.broughtForwardNotificationsTableNewTenureColumnLabel) {
                                    <td nowrap>
                                        {{interestsUiConfig.broughtForwardNotificationsTableNewTenureColumnLabel}}
                                    </td>
                                }
                                @if (interestsUiConfig.broughtForwardNotificationsTableActionDocColumnLabel) {
                                    <td nowrap>
                                        {{interestsUiConfig.broughtForwardNotificationsTableActionDocColumnLabel}}
                                    </td>
                                }
                                @if (interestsUiConfig.broughtForwardNotificationsTableActionDetailsColumnLabel) {
                                    <td nowrap>
                                        {{interestsUiConfig.broughtForwardNotificationsTableActionDetailsColumnLabel}}
                                    </td>
                                }
                                <td nowrap>{{interestsUiConfig.newInterestsTableCommentsColumnLabel}}</td>
                                <td
                                    nowrap
                                    class="custom-header"
                                    title=""></td>
                            </tr>
                        </thead>
                    }
                    <tbody>
                        <!-- track by? -->
                        @for (formerTenInNotification of formerTenureInterestsNotifications; track formerTenInNotification) {
                            <tr data-test-automation="tenure-interest">
                                <td class="text-left">{{getSubjectText(formerTenInNotification)}}</td>
                                <td class="text-left">{{formerTenInNotification.identifier}}</td>
                                <td class="text-left">{{formerTenInNotification.endorsement}}</td>
                                <td class="text-left">
                                    @if (formerTenInNotification.originDocument) {
                                        <div>{{formerTenInNotification.originDocument}}</div>
                                    }
                                    @if (formerTenInNotification.originPlan) {
                                        <div>{{formerTenInNotification.originPlan}}</div>
                                    }
                                </td>
                                <td class="text-left">{{formerTenInNotification.treatmentAction?.description}}</td>
                                @if (interestsUiConfig.broughtForwardNotificationsTableNewTenureColumnLabel) {
                                    <td class="text-left">
                                        {{getNewTenureText(formerTenInNotification)}}
                                    </td>
                                }
                                @if (interestsUiConfig.broughtForwardNotificationsTableActionDocColumnLabel) {
                                    <td>
                                        {{formerTenInNotification.treatmentDocument}}
                                    </td>
                                }
                                @if (interestsUiConfig.broughtForwardNotificationsTableActionDetailsColumnLabel) {
                                    <td>
                                        @for (actionDetails of getActionDetailsList(formerTenInNotification); track actionDetails) {
                                            <div>
                                                {{actionDetails}}
                                            </div>
                                        }
                                    </td>
                                }
                                @if (interestsUiConfig.newInterestsTableCommentsColumnLabel) {
                                    <td
                                        class="text-left"
                                        style="width:270px;">
                                        {{formerTenInNotification.comments}}
                                    </td>
                                }
                                <td
                                    class="vertical-middle text-right"
                                    style="width:100px;padding:8px">
                                    <!-- TODO PAU-232 -->
                                    <!-- Add || newInterestsNotificationsController.hasInvalidPlanDetails() to the ngClass statement -->
                                    @if (((['EDIT_INTERESTS'] | hasPermissions) && !(['EDIT_INTERESTS'] | disabledByPermissions) && !readOnly)) {
                                        <div>
                                            @if (!formerTenInNotification.treatmentAction) {
                                                <i
                                                    class="nlrp-icon nlrp-icon-error error"
                                                    title="This interest has not been actioned"
                                                    (click)="!readOnly && openFormerTenureInterestModal(formerTenInNotification)"
                                                    data-test-automation="set-action"></i>
                                            }
                                            @if (actionsPdfCreationMethodInvalidForPlan(formerTenInNotification.treatmentAction)) {
                                                <i
                                                    class="nlrp-icon nlrp-icon-error error"
                                                    title=""></i>
                                            }
                                            <!-- TODO PAU-232 -->
                                            <!-- Add && newInterestsNotificationsController.hasInvalidPlanDetails() to the click statement -->
                                            <i
                                                class="nlrp-icon nlrp-icon-edit"
                                                id="editFormerTenureInterestOrNotification"
                                                title="Edit former tenure interest or notification"
                                                (click)="!populateFormerTenuresInProgress && !readOnly
                                        && openFormerTenureInterestModal(formerTenInNotification)"
                                                data-test-automation="edit-interest"></i>
                                            @if (formerTenInNotification.portalCreated) {
                                                <i
                                                    class="nlrp-icon nlrp-icon-trash"
                                                    title="Remove portal-created former tenure interest"
                                                    (click)="!readOnly && deleteFormerTenureInterestNotification(formerTenInNotification)"
                                                    data-test-automation="remove-manual-former-tenure-interest"></i>
                                            }
                                            <!-- TODO PAU-232 -->
                                            <!-- Add && newInterestsNotificationsController.hasInvalidPlanDetails() to the click statement -->
                                            @if (noActionVisible(formerTenInNotification)) {
                                                <i
                                                    class="nlrp-icon nlrp-icon-check-box-indeterminate"
                                                    [ngClass]="{'disabled': noActionDisabled(formerTenInNotification)}"
                                                    title="Set the interest to 'No action'"
                                                    (click)="!populateFormerTenuresInProgress && !readOnly
                                        && noActionClick(formerTenInNotification)"
                                                    data-test-automation="set-no-action"></i>
                                            }
                                        </div>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
    <!-- track by? -->
    @for (missingNotificationTenure of missingNotificationTenures; track missingNotificationTenure) {
        <div
            class="row"
            data-test-automation="missing-notification-tenures">
            <div class="col-xs-12">
                <div class="checkbox-inline">
                    <i class="nlrp-icon nlrp-icon-verified-passed active"></i>
                    <span>
                        {{getDisplayMessageForIdentifier("noNotificationsFromParentTitleMessage", missingNotificationTenure.identifier)}}
                    </span>
                </div>
            </div>
        </div>
    }
    @for (
        nonDigitalTitlesForNotificationTenure of nonDigitalTitlesForNotificationTenures;
        track nonDigitalTitlesForNotificationTenure;
        let nonDigitalTitleIndex = $index
    ) {
        <div
            class="row"
            data-test-automation="non-digital-titles">
            <div class="col-xs-12">
                <div class="checkbox-inline">
                    <i class="nlrp-icon nlrp-icon-error error"></i>
                    <span>
                        {{getDisplayMessageForIdentifier("noDigitalTitleMessage", nonDigitalTitlesForNotificationTenure.identifier)}}
                    </span>
                    <div style="padding-left: 20px;">
                        <label class="control-label required-input">
                            <span>
                                {{getDisplayMessage("notificationsToAddressOnNonDigitalParentTitleQuestion")}}
                            </span>
                        </label>
                        <div
                            class="input-group"
                            data-test-automation="partially-surrendered">
                            @for (option of partiallySurrenderedViewOptions; track option) {
                                <label class="nlr-radio">
                                    @if ((['EDIT_INTERESTS', 'VIEW_INTERESTS'] | hasPermissions)) {
                                        <input
                                            type="radio"
                                            [ngClass]="{'has-radio-error': partiallySurrenderedInput | formFieldHasError}"
                                            [name]="'broughtForwardPartiallySurrendered' + nonDigitalTitleIndex"
                                            #partiallySurrenderedInput="ngModel"
                                            [(ngModel)]="nonDigitalTitlesForNotificationTenure.partiallySurrendered"
                                            [value]="option.value"
                                            [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions)"
                                            required
                                            title=""
                                            [attr.data-test-automation]="'partially-surrendered-option-' + option.value" />
                                    }
                                    <span>{{option.displayValue}}</span>
                                </label>
                            }
                            <!-- On a digital plan the notifications can be entered manually with Add below, so the plan is not
                                 blocked - unless Add is out of reach, in which case the alert still explains the problem -->
                            @if (
                                nonDigitalTitlesForNotificationTenure.partiallySurrendered
                                && (!isDigitalPlan() || !(['EDIT_INTERESTS'] | hasPermissions))
                            ) {
                                <div class="checkbox-inline">
                                    <i
                                        class="nlrp-icon nlrp-icon-error error"
                                        style="margin-left: 30px"></i>
                                    <span>
                                        {{getDisplayMessage("noManualNotificationsNonDigitalParentTitleAlert")}}
                                    </span>
                                </div>
                            }
                        </div>
                        <!-- A declaration of Yes has to be backed up with at least one manually entered interest or
                             notification. The hidden control carries that requirement into interestsForm so it blocks
                             Validate and lodgement the same way an unanswered mandatory field does -->
                        @if (
                            nonDigitalTitlesForNotificationTenure.partiallySurrendered
                            && isDigitalPlan()
                            && (['EDIT_INTERESTS'] | hasPermissions)
                            && !readOnly
                        ) {
                            <input
                                type="hidden"
                                #manualNotificationAdded="ngModel"
                                [name]="'broughtForwardManualNotificationAdded' + nonDigitalTitleIndex"
                                [ngModel]="hasManualNotificationFor(nonDigitalTitlesForNotificationTenure) || null"
                                required />
                            <!-- Informational until the user has had their chance to act on it, and an error once
                                 Validate has been pressed - the requirement blocks either way, only the level changes -->
                            @if (!hasManualNotificationFor(nonDigitalTitlesForNotificationTenure)) {
                                <div
                                    class="alert"
                                    [ngClass]="(manualNotificationAdded | formFieldHasError) ? 'alert-danger' : 'alert-info'"
                                    data-test-automation="manual-notification-required">
                                    At least one interest or notification must be added for this former tenure.
                                </div>
                            }
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    @for (noTitleReferenceTenure of noTitleReferences; track noTitleReferenceTenure; let noTitleReferenceIndex = $index) {
        <div
            class="row"
            data-test-automation="no-title-reference-tenure">
            <div class="col-xs-12">
                <div class="checkbox-inline">
                    <i class="nlrp-icon nlrp-icon-error error"></i>
                    <span>
                        {{getDisplayMessageForIdentifier("noTitleEnteredMessage", noTitleReferenceTenure.identifier)}}
                    </span>
                    <div style="padding-left: 20px;">
                        <label class="control-label required-input">
                            <span>
                                {{getDisplayMessage("subjectLandTitleExistenceQuestion")}}
                            </span>
                        </label>
                        <div
                            class="input-group"
                            data-test-automation="subject-land-title-exists">
                            @for (option of titleExistenceViewOptions; track option) {
                                <label
                                    class="nlr-radio"
                                    title="">
                                    @if ((['EDIT_INTERESTS', 'VIEW_INTERESTS'] | hasPermissions)) {
                                        <input
                                            type="radio"
                                            [ngClass]="{'has-radio-error': subjectLandTitleExistsInput | formFieldHasError}"
                                            [name]="'subjectLandTitleExists' + noTitleReferenceIndex"
                                            #subjectLandTitleExistsInput="ngModel"
                                            [(ngModel)]="noTitleReferenceTenure.subjectLandTitleExists"
                                            [value]="option.value"
                                            [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions)"
                                            required
                                            [attr.data-test-automation]="'subject-land-title-exists-option-' + option.value" />
                                    }
                                    <span>{{option.displayValue}}</span>
                                </label>
                            }
                            @if (noTitleReferenceTenure.subjectLandTitleExists) {
                                <div class="checkbox-inline">
                                    <i
                                        class="nlrp-icon nlrp-icon-error error"
                                        style="margin-left: 30px"></i>
                                    <span>
                                        {{getDisplayMessageForIdentifier("titleMustBeEnteredAlert", noTitleReferenceTenure.identifier)}}
                                        <input
                                            type="checkbox"
                                            class="hidden"
                                            name="noTitleReferenceTenureError"
                                            [ngModel]="noTitleReferenceTenure['noTitleReferenceTenureError' + noTitleReferenceIndex]"
                                            required />
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    @for (stagedTenure of bringForwardStagedSubdivisionInterestsTenures; track stagedTenure) {
        <div
            class="row"
            data-test-automation="staged-subdivision-tenure">
            <div class="col-xs-12">
                <div class="checkbox-inline">
                    <i class="nlrp-icon nlrp-icon-error error"></i>
                    <span>
                        {{getDisplayMessageForIdentifier("dplNoTitleMessage", getStagedTenureIdentifier(stagedTenure))}}
                    </span>
                    <div style="padding-left: 20px;">
                        <label class="control-label">
                            <span>{{getDisplayMessage("dplStagedSubdivisionBringForwardsFTNQuestion")}}</span>
                        </label>
                        <div
                            class="input-group"
                            data-test-automation="staged-subdivision-question">
                            @if ((['EDIT_INTERESTS', 'VIEW_INTERESTS'] | hasPermissions)) {
                                @for (option of bringForwardStagedSubdivisionInterestsViewOptions; track option) {
                                    <label class="nlr-radio">
                                        <input
                                            type="radio"
                                            [name]="'bringForwardStagedSubdivisionInterests_' + stagedTenure.id"
                                            [(ngModel)]="stagedTenure.bringForwardStagedSubdivisionInterests"
                                            [value]="option.value"
                                            [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions) || readOnly"
                                            (ngModelChange)="setStagedSubdivision(stagedTenure, $event)"
                                            required />
                                        <span>{{option.displayValue}}</span>
                                    </label>
                                }
                            }
                        </div>
                        <!-- As with a declared paper title, a declaration of Yes has to be backed up with at least one
                             manually entered interest or notification, and the hidden control carries that requirement
                             into interestsForm so it blocks Validate and lodgement -->
                        @if (
                            stagedTenure.bringForwardStagedSubdivisionInterests
                            && (['EDIT_INTERESTS'] | hasPermissions)
                            && !readOnly
                            && !hasManualNotificationForStagedTenure(stagedTenure)
                        ) {
                            <input
                                type="hidden"
                                #stagedManualNotificationAdded="ngModel"
                                [name]="'bringForwardStagedSubdivisionManualNotificationAdded_' + stagedTenure.id"
                                [ngModel]="null"
                                required />
                            <!-- Informational until the user has had their chance to act on it, and an error once
                                 Validate has been pressed - the requirement blocks either way, only the level changes -->
                            <div
                                class="alert"
                                [ngClass]="(stagedManualNotificationAdded | formFieldHasError) ? 'alert-danger' : 'alert-info'"
                                data-test-automation="staged-manual-notification-required">
                                At least one interest or notification must be added for this former tenure.
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    @if (hasStagedSubdivisionPortalCreatedFTNs()) {
        <div
            class="row"
            data-test-automation="staged-subdivision-add-warning">
            <div class="col-xs-12">
                <div class="checkbox-inline">
                    <i class="nlrp-icon nlrp-icon-error error"></i>
                    <span>Please refer back to the parent plan to ensure all former tenure interests are carried forwards</span>
                </div>
            </div>
        </div>
    }

    <div class="container-fluid">
        <div class="row buttons">
            <div class="button-group">
                @if ((['EDIT_INTERESTS'] | hasPermissions)) {
                    <button
                        id="formerTenureInterestsRefreshBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm validate"
                        (click)="refreshFormerTenInNotifications()"
                        [ngClass]="{'disabled':(['EDIT_INTERESTS'] | disabledByPermissions) || isRefreshButtonDisabled() || readOnly}"
                        title="Refresh former tenure interests and notifications"
                        data-test-automation="refresh-interests">
                        Refresh
                        @if (populateFormerTenuresInProgress) {
                            <i class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"></i>
                        }
                    </button>
                }

                @if (
                    (['EDIT_INTERESTS'] | hasPermissions)
                    && (hasDeclaredPaperTitleNotifications() || hasStagedSubdivisionFormerTenures() || canAddEncumbranceScheduleInterests())
                    && isDigitalPlan()
                ) {
                    <button
                        id="formerTenureInterestsAddBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm validate"
                        (click)="addNewFormerTenureInterestNotification()"
                        [ngClass]="{'disabled': (['EDIT_INTERESTS'] | disabledByPermissions) || readOnly}"
                        title="Add former tenure interest or notification"
                        data-test-automation="add-manual-former-tenure-interest">
                        Add
                    </button>
                }
            </div>
        </div>
    </div>
</div>

@if (invalidFormerTenureText) {
    <div class="help-block">
        <span>Error!</span>
        <span>
            {{invalidFormerTenureText}}
        </span>
    </div>
}
